import { render, staticRenderFns } from "./SettleGather.vue?vue&type=template&id=36eab168&"
import script from "./SettleGather.vue?vue&type=script&lang=js&"
export * from "./SettleGather.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports